const IntroDisplay = ({hotspotData, keyId, ...props}) => {
    return (
        <div className="display-intro-column fade-in">
            { hotspotData.title && 
                <h3>{hotspotData.title}</h3>
            }

            { hotspotData.paragraphs && 
                <div key={keyId} className="intro-info-in-col auto-height">
                    { hotspotData.paragraphs.map((p, index) => {
                        if (p.subtitle) {
                            return (
                                <div key={index}>
                                    <h4>{p.subtitle}</h4>
                                    { p.type === "instructions" ? 
                                        <p style={{ fontWeight: 'bold' }}>{p.text}</p>
                                    : 
                                        <p>{p.text}</p>
                                    }
                                </div>
                            )
                        } else {
                            return (
                                <div key={index}>
                                    { p.type === "instructions" ? 
                                        <p style={{ fontWeight: 'bold' }}>{p.text}</p>
                                    : 
                                        <p>{p.text}</p>
                                    }
                                </div>
                            )
                        }
                    }) }
                </div>
            }
        </div>
    );
}

export default IntroDisplay;